var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldFolderCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 8.25V6.42C2 3.98 3.98 2 6.42 2h2.32c1.63 0 2.14.53 2.79 1.4l1.4 1.86c.31.41.35.46.93.46h2.79c2.31 0 4.28 1.47 5.02 3.53H3a1 1 0 0 1-1-1z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 11.75v4.9C2 19.6 4.4 22 7.35 22h9.3C19.6 22 22 19.6 22 16.65l-.017-4.903a1 1 0 0 0-1-.997H3a1 1 0 0 0-1 1zm11.81 6.75c-.19 0-.39-.08-.53-.22l-1.24-1.24-1.28 1.28c-.14.14-.34.22-.53.22s-.38-.08-.53-.22a.754.754 0 0 1 0-1.06l1.28-1.28-1.24-1.24a.754.754 0 0 1 0-1.06c.3-.29.77-.29 1.06 0l1.24 1.24 1.2-1.2c.29-.29.76-.29 1.06 0 .29.3.29.77 0 1.06l-1.2 1.2 1.24 1.24c.29.29.29.77 0 1.06-.15.14-.34.22-.53.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldFolderCross);
export default __webpack_public_path__ + "static/media/vuesax-bold-folder-cross.9abf3bac7f5e6ed1b62660e06e23e6a0.svg";
export { ForwardRef as ReactComponent };